import Vue from 'vue'
import { RootState } from './types'
import { auth } from './auth/index'
import Vuex, { StoreOptions } from 'vuex'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  modules: {
    auth
  }
}

export default new Vuex.Store<RootState>(store)
